module.exports = __webpack_public_path__ + "img/appAsset-brand--fc.006f6174.svg";